import Calendar from "../../../../../components/calendar/Calendar";
import Input from "../../../../../components/inputText/Input";
import RadioButton from "../../../../../components/radioButton/RadioButton";
import Autocomplete from "../../../../../components/Autocomplete/Autocomplete";
import MediaQueryUtils from "../../../../../utils/MediaQueryUtils";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {removeSingleFile, setStateAssistente, setUpload} from "../../../../../actions/IndexActions";
import {store} from '../../../../../config/configureStore';
import $ from "jquery"
import styleDatiPersonali from "./DatiPersonali.module.css";
import styleButton from "../../../../../components/Button/Button.module.css";
import Utils from "../../../../../utils/Utils";
import Spinner from "../../../../../components/spinner/Spinner";

function DatiAnagrafici(props) {

    let isPageWide = MediaQueryUtils('(min-width: 1150px)')
    const comuni = JSON.parse(sessionStorage.getItem("comuni"))
    const province = JSON.parse(sessionStorage.getItem("siglaProvince"))
    const nazioni = JSON.parse(sessionStorage.getItem("nazioni"))
    const comuniAndNazioni = nazioni.concat(comuni)
    const [state, setState] = useState({})
    const [rerenderAutocomplete, setRerenderAutocomplete] = useState(0)
    const [rerenderCalendar, setRerenderCalendar] = useState(0)
    const [arrayDocumentoIdentita, setArrayDocumentoIdentita] = useState(0)
    const [arrayPermessoSoggiorno, setArrayPermessoSoggiorno] = useState(0)
    const [renderDocumentoIdentita, setRenderDocumentoIdentita] = useState(0)
    const [renderPermessoSoggiorno, setRenderPermessoSoggiorno] = useState(0)
    const dispatch = useDispatch()
    const getAssistente = useSelector(state => state.wizardReducer)
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}
    const flagInserimentoManuale = useSelector(state => state.wizardReducer.flagInserimentoManuale)
    const [showSpinner, setShowSpinner] = useState(false)
    const fileReducer = useSelector(state => state.fileReducer)
    const [maxSizeDocumentoIdentita, setMaxSizeDocumentoIdentita] = useState(false)
    const [maxSizeSoggiorno, setMaxSizeSoggiorno] = useState(false)

    useEffect(() => {
        if (getAssistente && getAssistente.datiAnagrafici) {
            setState(getAssistente.datiAnagrafici)
            dispatch(setStateAssistente("datiAnagrafici", getAssistente.datiAnagrafici))
        } else if (props.datiAnagrafici) {
            setState({...props.datiAnagrafici})
            dispatch(setStateAssistente("datiAnagrafici", {...props.datiAnagrafici}))
        }
        setRerenderAutocomplete(rerenderAutocomplete + 1)
        setRerenderCalendar(rerenderCalendar + 1)
    }, [])

    useEffect( ()=> {
        showFile("documentoIdentita")
    }, [renderDocumentoIdentita, setRenderDocumentoIdentita] )

    useEffect( ()=> {
        showFile("permessoSoggiorno")
    }, [renderPermessoSoggiorno, setRenderPermessoSoggiorno] )

    function riceviValore(id, value, index, nomeOggetto) {
        let wReducer = store.getState().wizardReducer
        let newState = wReducer.datiAnagrafici ? {...wReducer.datiAnagrafici} : {...state}
        let newId = /\d/.test(id) ? id.replace(new RegExp("[0-9]", "g"), "") : id
        if (nomeOggetto) {
            if (!newState[nomeOggetto] && (nomeOggetto === "indirizzi" || nomeOggetto === "documenti")) {
                newState[nomeOggetto] = [{}, {}]
            } else if (!newState[nomeOggetto] && nomeOggetto === "contatti") {
                newState[nomeOggetto] = [{}]
            }
            if (!newState[nomeOggetto][index]) {
                newState[nomeOggetto][index] = {}
            }
            if (nomeOggetto === "documenti" && id.includes("1")) {
                newState[nomeOggetto][index]["tipo"] = 1
            } else if (nomeOggetto === "documenti" && id.includes("2")) {
                newState[nomeOggetto][index]["tipo"] = 2
            }
            newState[nomeOggetto][index][newId] = value
        } else {
            newState[newId] = value
        }
        if(newId === "comuneNascita" && value && value.codice && value.codice.length <= 4 ){
            newState["provinciaNascita"] = ""
            $(document).ready(function() {
                $("#provinciaNascita").val("");
            })
        }
        if(newState["indirizzi"] && newState["indirizzi"].length > 0 && newState["indirizzi"][0]  && newState["indirizzi"][0].comune && newState["indirizzi"][0].comune.codice && newState["indirizzi"][0].comune.codice.length <= 4){
            newState["indirizzi"][0].provincia = ""
            newState["indirizzi"][0].cap = ""
            $(document).ready(function() {
                $("#provincia1").val("");
            })
        }
        dispatch(setStateAssistente("datiAnagrafici", newState))
        setState(newState)
    }

    function isDataNonValida(value) {
        return !!(Utils.isValorizzato(value) && !Utils.isDateItaValid(value))
    }

    function ricevivaloreRadioButtonDomicilio(id, value) {
        let newState = {...state}
        newState["residenzaDiversaDomicilio"] = value
        if (newState.indirizzi) {
            if (newState.indirizzi.length > 0 && newState.indirizzi[0] && newState.indirizzi[1] && value === "false") {
                newState.indirizzi[1] = {...newState.indirizzi[0]}
            } else {
                newState.indirizzi[1] = {}
            }
        }
        setState(newState)
        dispatch(setStateAssistente("datiAnagrafici", newState))
        setRerenderAutocomplete(rerenderAutocomplete + 1)
    }

    function uploadFile(event) {
        setShowSpinner(true)
        if(event.target.files[0].size > 1000000){
            if (event.target.id === "documentoIdentita") setMaxSizeDocumentoIdentita(true)
            else if(event.target.id === "permessoSoggiorno") setMaxSizeSoggiorno(true)

            setShowSpinner(false)
        }
        else {
            Utils.toBase64(event.target.files[0]).then(res => {
                if (res) {
                    let newStateUpload = {...fileReducer}
                    newStateUpload[event.target.id] = {
                        nomeFile: event.target.files[0].name,
                        fileBase64: res
                    }
                    dispatch(setUpload([event.target.id], newStateUpload[event.target.id]))
                    if (event.target.id === "documentoIdentita"){
                        setMaxSizeDocumentoIdentita(false)
                        setRenderDocumentoIdentita(renderDocumentoIdentita + 1)
                    }
                    else if (event.target.id === "permessoSoggiorno"){
                        setMaxSizeSoggiorno(false)
                        setRenderPermessoSoggiorno(renderPermessoSoggiorno + 1)
                    }
                }
                setShowSpinner(false)
            }).catch(reason => {
                setShowSpinner(false)
                console.log("Errore Operation Caricamento File: " + reason)
            })
        }

    }

    // Etichetta leggibile del documento, usata negli aria-label dei bottoni
    // scarica/elimina per dire chiaramente su cosa agisce l'azione.
    function nomeDocumento(path){
        return path === "documentoIdentita" ? "documento di identità" : "permesso di soggiorno"
    }

    function showFile(path){

        let showFiles = []

        if(fileReducer && fileReducer[path]){
                let showFile = (
                    <div className={"row"}>
                        <br/>
                        <div className={"col-4"}>
                            <span>{fileReducer[path].nomeFile}</span>
                        </div>
                        <div className={"col-1"} >
                            {/* Gli SVG di scarica/elimina erano <svg onClick>: non
                                raggiungibili ne' attivabili da tastiera (WCAG 2.1.1).
                                Ora sono avvolti in <button type="button"> con reset di
                                stile, quindi la resa grafica resta identica; il nome
                                accessibile lo da' l'aria-label del button e gli SVG sono
                                aria-hidden. */}
                            <button type="button"
                                    onClick={() => downloadFile(path)}
                                    aria-label={"Scarica ".concat(nomeDocumento(path)).concat(": ").concat(fileReducer[path].nomeFile)}
                                    style={{background: "none", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer", lineHeight: 0, verticalAlign: "middle"}}>
                                <svg
                                    aria-hidden="true" focusable="false"
                                    xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#1b7ea9"
                                    className="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
                                    <path
                                        d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z"/>
                                    <path
                                        d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                                </svg>
                            </button>

                            <button type="button"
                                    onClick={() => removeFile(path)}
                                    aria-label={"Elimina ".concat(nomeDocumento(path)).concat(": ").concat(fileReducer[path].nomeFile)}
                                    style={{background: "none", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer", marginLeft: "15px", lineHeight: 0, verticalAlign: "middle"}}>
                                <svg aria-hidden="true" focusable="false"
                                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red"
                                     className="bi bi-trash" viewBox="0 0 16 16">
                                    <path
                                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                    <path fillRule="evenodd"
                                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                )
            showFiles.push(showFile)
        }

        if(path === "documentoIdentita") return setArrayDocumentoIdentita(showFiles)
        else return setArrayPermessoSoggiorno(showFiles)
    }

    function downloadFile(path){
        (function() {
                // convert base64 string to byte array
                var byteCharacters = path === "documentoIdentita" ? atob(fileReducer.documentoIdentita.fileBase64) : atob(fileReducer.permessoSoggiorno.fileBase64);
                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);

                // now that we have the byte array, construct the blob from it
                var blob1 = new Blob([byteArray], {type: "application/octet-stream"});

                var fileName1 = path === "documentoIdentita" ? fileReducer.documentoIdentita.nomeFile : fileReducer.permessoSoggiorno.nomeFile;
                Utils.saveAs(blob1, fileName1);
            })();
    }

    function removeFile(path){
        dispatch(removeSingleFile(path))
        let persistRoot = JSON.parse(localStorage.getItem("persist:root"))
        let wReducer = JSON.parse(persistRoot.wizardReducer)
        let newState = wReducer.datiAnagrafici ? {...wReducer.datiAnagrafici} : {...state}
        let tipoDocumento = path === "documentoIdentita" ? 1 : 2
        newState.documenti.forEach((documento,index) => {
            if(documento.tipo && documento.tipo === tipoDocumento){
                newState.documenti[index] = {}
            }
        })
        setState(newState)
        dispatch(setStateAssistente("datiAnagrafici", newState))
        if(path === "documentoIdentita") setRenderDocumentoIdentita(renderDocumentoIdentita + 1)
        else setRenderPermessoSoggiorno(renderPermessoSoggiorno + 1)
    }


    return (
        <div>
            <Spinner show={showSpinner}/>
            <div className={"row"} style={{borderBottom: "2px solid #d9dadb", paddingBottom: "1rem"}}>
                <div className={isPageWide ? "col-10" : "col-7"}>
                    <span style={{color: "#909090", fontWeight: "bold"}}>Dati Generali</span>
                </div>
                <div className={isPageWide ? "col-2" : "col-5"}>
                    <span style={{color: "red", fontWeight: "bold"}}>*Campo Obbligatorio</span>
                </div>
            </div>
            <div className={"col-12"} style={{borderBottom: "2px solid #d9dadb", marginTop: "1rem"}}>
                    <div style={{width: isPageWide ? "25%" : "45%"}}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Cognome<span
                            className={"obbligatorietaColor"}>*</span></span>
                        <br/>
                        <Input id={"cognome"}
                               ariaLabel={"Cognome (obbligatorio)"}
                               value={state.cognome ? state.cognome : ""}
                               onChange={(event) => riceviValore(event.target.id, event.target.value)}
                               placeholder={"Cognome"}/>
                    </div>
                    <div style={{marginTop: "10px", width: isPageWide ? "25%" : "45%"}}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Nome<span
                            className={"obbligatorietaColor"}>*</span></span>
                        <br/>
                        <Input id={"nome"}
                               ariaLabel={"Nome (obbligatorio)"}
                               value={state.nome ? state.nome : ""}
                               onChange={(event) => riceviValore(event.target.id, event.target.value)}
                               placeholder={"Nome"}/>
                    </div>
                    <div style={{marginTop: "10px", width: isPageWide ? "25%" : "45%"}}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Sesso<span
                            className={"obbligatorietaColor"}>*</span></span>
                        <br/>
                        <RadioButton id={"sesso1"}
                                     text={"M"}
                                     onChange={(event) => riceviValore(event.target.id, event.target.value)}
                                     value={"M"}
                                     checked={state && state.sesso && state.sesso === "M"}
                        >
                        </RadioButton>
                        <RadioButton id={"sesso2"}
                                     text={"F"}
                                     value={"F"}
                                     onChange={(event) => riceviValore(event.target.id, event.target.value)}
                                     checked={state && state.sesso && state.sesso === "F"}
                        />
                    </div>
                    <div style={{marginTop: "10px", width: isPageWide ? "25%" : "45%"}}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Data di Nascita<span
                            className={"obbligatorietaColor"}>*</span></span>
                        <br/>
                        <Calendar id={"dataNascita"} ariaLabel={"Data di Nascita (obbligatorio)"} rerender={rerenderCalendar}
                                  disabled={props.datiAnagrafici && props.datiAnagrafici.dataNascita}
                                  value={state.dataNascita ? state.dataNascita : ""} onChange={riceviValore}
                                  errorClause={isDataNonValida(state.dataNascita)}
                                  errorMessage={"La data non è valida"}/>
                    </div>
                    <div style={{marginTop: "10px", width: isPageWide ? "25%" : "45%"}}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Comune (o Stato estero) di Nascita<span
                            className={"obbligatorietaColor"}>*</span></span>
                        <br/>
                        <Autocomplete id={"comuneNascita"}
                                      ariaLabel={"Comune (o Stato estero) di Nascita (obbligatorio)"}
                                      value={state.comuneNascita ? state.comuneNascita : ""}
                                      onChange={riceviValore}
                                      placeholder={"Comune Nascita"}
                                      suggestions={comuniAndNazioni}
                                      rerender={rerenderAutocomplete}
                        />
                    </div>
                    <div style={{marginTop: "10px", width: isPageWide ? "25%" : "45%"}}>
                        <span
                            style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Provincia di Nascita
                            {state.comuneNascita && state.comuneNascita.codice && state.comuneNascita.codice.length <= 4 ? <></> :
                                <span className={"obbligatorietaColor"}>*</span>}
                        </span>
                        <br/>
                        <Autocomplete id={"provinciaNascita"}
                                      ariaLabel={"Provincia di Nascita (obbligatorio)"}
                                      value={state.provinciaNascita ? state.provinciaNascita : ""}
                                      onChange={riceviValore}
                                      placeholder={"Provincia Nascita"}
                                      suggestions={province}
                                      disabled={state.comuneNascita && state.comuneNascita.codice && state.comuneNascita.codice.length <= 4}
                                      rerender={rerenderAutocomplete}
                        />
                    </div>
                    <div style={{marginTop: "10px", width: isPageWide ? "25%" : "45%"}}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Cittadinanza<span
                            className={"obbligatorietaColor"}>*</span></span>
                        <br/>
                        <Autocomplete id={"cittadinanza"}
                                      ariaLabel={"Cittadinanza (obbligatorio)"}
                                      value={state.cittadinanza ? state.cittadinanza : ""}
                                      onChange={riceviValore}
                                      placeholder={"Cittadinanza"}
                                      suggestions={nazioni}
                                      rerender={rerenderAutocomplete}
                        />
                    </div>
                    <div style={{marginTop: "10px", marginBottom: "2rem", width: isPageWide ? "25%" : "45%"}}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Codice Fiscale<span
                            className={"obbligatorietaColor"}>*</span></span>
                        <br/>
                        <Input id={"codiceFiscale"}
                               ariaLabel={"Codice Fiscale (obbligatorio)"}
                               value={state.codiceFiscale ? state.codiceFiscale : ""}
                               onChange={(event) => riceviValore(event.target.id, event.target.value)}
                               placeholder={"Codice Fiscale"}/>
                    </div>
                </div>


            <div className={"row"}
                 style={{borderBottom: "2px solid #d9dadb", paddingBottom: "1rem", paddingTop: "1rem"}}>
                <div className={isPageWide ? "col-10" : "col-7"}>
                    <span style={{color: "#909090", fontWeight: "bold"}}>Documenti</span>
                </div>
                <div className={isPageWide ? "col-2" : "col-5"}>
                    <span style={{color: "red", fontWeight: "bold"}}>*Campo Obbligatorio</span>
                </div>
            </div>


            <div className={"col-12"} style={{borderBottom: "2px solid #d9dadb", marginTop: "1rem"}}>
                <div>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>
                        Documento di Identità
                        {!fileReducer || fileReducer.documentoIdentita || !fileReducer.permessoSoggiorno ?
                            <span className={"obbligatorietaColor"}>*</span> : <></>}
                    </span>
                    {arrayDocumentoIdentita}
                    <br/>
                    {!(fileReducer && fileReducer.documentoIdentita) ?
                    <label htmlFor={"documentoIdentita"} style={{cursor:"pointer", width: "110px", height: "45px"}} className={" ".concat(styleDatiPersonali.buttonFile).concat(" ").concat(styleButton.btnBlu)}>
                        {/* L'input era display:none, quindi non focusabile: il caricamento
                            del file era impossibile da tastiera (WCAG 2.1.1). Ora e' solo
                            nascosto visivamente ma resta nel flusso di tabulazione; la
                            label lo referenzia con htmlFor e ne fornisce il nome
                            accessibile. La resa grafica non cambia. */}
                        <input id={"documentoIdentita"}
                               type="file"
                               accept={".jpg, .jpeg, .gif, .png, .pdf"}
                               onChange={(event => uploadFile(event))}
                               style={{opacity: 0, position: "absolute", width: "0.1px", height: "0.1px", overflow: "hidden", zIndex: -1}}
                               multiple={false}
                        />
                        <p style={{margin:"auto"}}>Scegli file</p>
                    </label> : <></> }
                    {!(fileReducer && fileReducer.documentoIdentita) && maxSizeDocumentoIdentita ?
                        <div>
                            <span className={"obbligatorietaColor"} style={{fontWeight: "bold", fontSize: "14px"}}>
                                Dimensione massima di 1Mb superata
                            </span>
                        </div>
                        : <></>}
                </div>
                <div style={{marginTop: "10px", width: isPageWide ? "25%" : "45%"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Data di rilascio
                        {!fileReducer || fileReducer.documentoIdentita || !fileReducer.permessoSoggiorno ?
                        <span className={"obbligatorietaColor"}>*</span> : <></>}</span>
                    <br/>
                    <Calendar id={"dataRilascio1"} ariaLabel={"Data di rilascio documento di identità (obbligatorio)"} index={0} nomeOggetto={"documenti"} rerender={rerenderCalendar}
                              value={state.documenti && state.documenti[0] && state.documenti[0].tipo === 1 && state.documenti[0].dataRilascio ? state.documenti[0].dataRilascio : state.documenti && state.documenti[1] && state.documenti[1].tipo === 1 && state.documenti[1].dataRilascio?state.documenti[1].dataRilascio:""}
                              onChange={riceviValore}
                              errorClause={isDataNonValida(state.documenti && state.documenti[0] && state.documenti[0].tipo === 1 && state.documenti[0].dataRilascio ? state.documenti[0].dataRilascio : state.documenti && state.documenti[1] && state.documenti[1].tipo === 1 && state.documenti[1].dataRilascio?state.documenti[1].dataRilascio:"")}
                              errorMessage={"La data non è valida"}
                    />
                </div>
                <div style={{marginTop: "10px", width: isPageWide ? "25%" : "45%"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Ente di rilascio
                        {!fileReducer || fileReducer.documentoIdentita || !fileReducer.permessoSoggiorno ?
                        <span className={"obbligatorietaColor"}>*</span> : <></>}</span>
                    <br/>
                    <Input
                        id={"enteRilascio1"}
                        ariaLabel={"Ente di rilascio documento di identità (obbligatorio)"}
                        value={state.documenti && state.documenti[0] && state.documenti[0].tipo === 1 && state.documenti[0].enteRilascio ? state.documenti[0].enteRilascio : state.documenti && state.documenti[1] && state.documenti[1].tipo === 1 && state.documenti[1].enteRilascio?state.documenti[1].enteRilascio:""}
                        onChange={(event) => riceviValore(event.target.id, event.target.value, 0, "documenti")}
                        placeholder={"Ente"}
                    />
                </div>
                <div style={{marginTop: "10px", width: isPageWide ? "25%" : "45%"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Data Scadenza
                        {!fileReducer || fileReducer.documentoIdentita || !fileReducer.permessoSoggiorno ?
                        <span className={"obbligatorietaColor"}>*</span> : <></>}</span>
                    <br/>
                    <Calendar
                        id={"dataScadenza1"} ariaLabel={"Data Scadenza documento di identità (obbligatorio)"} index={0} nomeOggetto={"documenti"} rerender={rerenderCalendar}
                        value={state.documenti && state.documenti[0] && state.documenti[0].tipo === 1 && state.documenti[0].dataScadenza ? state.documenti[0].dataScadenza : state.documenti && state.documenti[1] && state.documenti[1].tipo === 1 && state.documenti[1].dataScadenza?state.documenti[1].dataScadenza:""}
                        onChange={riceviValore}
                        errorClause={isDataNonValida(state.documenti && state.documenti[0] && state.documenti[0].tipo === 1 && state.documenti[0].dataScadenza ? state.documenti[0].dataScadenza : state.documenti && state.documenti[1] && state.documenti[1].tipo === 1 && state.documenti[1].dataScadenza?state.documenti[1].dataScadenza:"")}
                        errorMessage={"La data non è valida"}
                    />
                </div>
                <div style={{marginTop: "10px"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>
                        Permesso di soggiorno
                        {!fileReducer || fileReducer.permessoSoggiorno || !fileReducer.documentoIdentita ?
                            <span className={"obbligatorietaColor"}>*</span> : <></>}
                    </span>
                    {arrayPermessoSoggiorno}
                    <br/>
                    {!(fileReducer && fileReducer.permessoSoggiorno) ?
                    <label htmlFor={"permessoSoggiorno"} style={{cursor:"pointer", width: "110px", height: "45px"}} className={" ".concat(styleDatiPersonali.buttonFile).concat(" ").concat(styleButton.btnBlu)}>
                        {/* Come sopra: input nascosto visivamente ma focusabile, con
                            htmlFor sulla label (WCAG 2.1.1). Resa grafica invariata. */}
                        <input id={"permessoSoggiorno"}
                               type="file"
                               accept={".jpg, .jpeg, .gif, .png, .pdf"}
                               onChange={(event => uploadFile(event))}
                               style={{opacity: 0, position: "absolute", width: "0.1px", height: "0.1px", overflow: "hidden", zIndex: -1}}
                               multiple={false}
                        />
                        <p style={{margin:"auto"}}>Scegli file</p>
                    </label> : <></> }
                    {!(fileReducer && fileReducer.permessoSoggiorno) && maxSizeSoggiorno ?
                        <div>
                            <span className={"obbligatorietaColor"} style={{fontWeight: "bold", fontSize: "14px"}}>
                                Dimensione massima di 1Mb superata
                            </span>
                        </div>
                        : <></>}
                </div>
                <div style={{marginTop: "10px", width: isPageWide ? "25%" : "45%"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>
                        Data di rilascio
                        {!fileReducer || fileReducer.permessoSoggiorno || !fileReducer.documentoIdentita ?
                            <span className={"obbligatorietaColor"}>*</span> : <></>}
                    </span>
                    <br/>
                    <Calendar
                        id={"dataRilascio2"} ariaLabel={"Data di rilascio permesso di soggiorno (obbligatorio)"} index={1} nomeOggetto={"documenti"} rerender={rerenderCalendar}
                        value={state.documenti && state.documenti[0] && state.documenti[0].tipo === 2 && state.documenti[0].dataRilascio ? state.documenti[0].dataRilascio : state.documenti && state.documenti[1] && state.documenti[1].tipo === 2 && state.documenti[1].dataRilascio?state.documenti[1].dataRilascio:""}
                        onChange={riceviValore}
                        errorClause={isDataNonValida(state.documenti && state.documenti[0] && state.documenti[0].tipo === 2 && state.documenti[0].dataRilascio ? state.documenti[0].dataRilascio : state.documenti && state.documenti[1] && state.documenti[1].tipo === 2 && state.documenti[1].dataRilascio?state.documenti[1].dataRilascio:"")}
                        errorMessage={"La data non è valida"}
                    />
                </div>
                <div style={{marginTop: "10px", width: isPageWide ? "25%" : "45%"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>
                        Ente di rilascio
                        {!fileReducer || fileReducer.permessoSoggiorno || !fileReducer.documentoIdentita ?
                            <span className={"obbligatorietaColor"}>*</span> : <></>}
                    </span>
                    <br/>
                    <Input
                        id={"enteRilascio2"} ariaLabel={"Ente di rilascio permesso di soggiorno (obbligatorio)"} index={1} nomeOggetto={"documenti"}
                        value={state.documenti && state.documenti[0] && state.documenti[0].tipo === 2 && state.documenti[0].enteRilascio ? state.documenti[0].enteRilascio : state.documenti && state.documenti[1] && state.documenti[1].tipo === 2 && state.documenti[1].enteRilascio?state.documenti[1].enteRilascio:""}
                        placeholder={"Ente"}
                        onChange={(event) => riceviValore(event.target.id, event.target.value, 1, "documenti")}
                    />
                </div>
                <div style={{marginTop: "10px", width: isPageWide ? "25%" : "45%", marginBottom: "2rem"}}>
                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>
                        Data Scadenza
                        {!fileReducer || fileReducer.permessoSoggiorno || !fileReducer.documentoIdentita ?
                            <span className={"obbligatorietaColor"}>*</span> : <></>}
                    </span>
                    <br/>
                    <Calendar
                        id={"dataScadenza2"} ariaLabel={"Data Scadenza permesso di soggiorno (obbligatorio)"} index={1} nomeOggetto={"documenti"} rerender={rerenderCalendar}
                        value={state.documenti && state.documenti[0] && state.documenti[0].tipo === 2 && state.documenti[0].dataScadenza ? state.documenti[0].dataScadenza : state.documenti && state.documenti[1] && state.documenti[1].tipo === 2 && state.documenti[1].dataScadenza?state.documenti[1].dataScadenza:""}
                        field={"dataScadenzaPermesso"}
                        onChange={riceviValore}
                        errorClause={isDataNonValida(state.documenti && state.documenti[0] && state.documenti[0].tipo === 2 && state.documenti[0].dataScadenza ? state.documenti[0].dataScadenza : state.documenti && state.documenti[1] && state.documenti[1].tipo === 2 && state.documenti[1].dataScadenza?state.documenti[1].dataScadenza:"")}
                        errorMessage={"La data non è valida"}
                    />
                </div>
            </div>

            <div className={"row"}
                 style={{borderBottom: "2px solid #d9dadb", paddingBottom: "1rem", paddingTop: "1rem"}}>
                <div className={isPageWide ? "col-10" : "col-7"}>
                    <span style={{color: "#909090", fontWeight: "bold"}}>Residenza e domicilio</span>
                </div>
                <div className={isPageWide ? "col-2" : "col-5"}>
                    <span style={{color: "red", fontWeight: "bold"}}>*Campo Obbligatorio</span>
                </div>
            </div>
            <div className={"col-12"} style={{borderBottom: "2px solid #d9dadb", marginTop: "1rem"}}>

                {!flagInserimentoManuale && (sessioneUtente && (sessioneUtente.tipoUtente === "01" || sessioneUtente.tipoUtente === "02" || sessioneUtente.tipoUtente === "03") && state.indirizzi && state.indirizzi.length > 0 && state.indirizzi[0].indirizzo) ?
                    <div>
                        <span style={{fontWeight: "bold"}}>Residenza</span>
                        <div className={"row"} style={{marginTop: "1rem"}}>
                            <div className={"col-4"}>
                                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Via/Piazza</span>
                                <br/>
                                <span>{state.indirizzi && state.indirizzi[0] && state.indirizzi[0].indirizzo ? state.indirizzi[0].indirizzo : ""}</span>
                            </div>
                            <div className={"col-4"}>
                                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>N.</span>
                                <br/>
                                <span>{state.indirizzi && state.indirizzi[0] && state.indirizzi[0].numeroCivico ? state.indirizzi[0].numeroCivico : ""}</span>
                            </div>
                        </div>
                        <div style={{marginTop: "10px"}}>
                            <div className={"row"}>
                                <div className={"col-4"}>
                                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Comune (o Stato estero)</span>
                                    <br/>
                                    <span>{state.indirizzi && state.indirizzi[0] && state.indirizzi[0].comune && state.indirizzi[0].comune.descrizione ? state.indirizzi[0].comune.descrizione : ""}</span>
                                </div>
                                <div className={"col-2"}>
                                    <span style={{
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                        color: "#505050"
                                    }}>Provincia</span>
                                    <br/>
                                    <span>{state.indirizzi && state.indirizzi[0] && state.indirizzi[0].provincia && state.indirizzi[0].provincia.descrizione ? state.indirizzi[0].provincia.descrizione : ""}</span>
                                </div>
                                <div className={"col-2"}>
                                    <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>CAP</span>
                                    <br/>
                                    <span>{state.indirizzi && state.indirizzi[0] && state.indirizzi[0].cap ? state.indirizzi[0].cap : ""}</span>
                                </div>
                            </div>
                        </div>
                    </div> : <div>
                        <div className={"row"} style={{marginTop: "1rem"}}>
                            <div className={"col-4"}>
                                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Via/Piazza<span
                                    className={"obbligatorietaColor"}>*</span></span>
                                <br/>
                                <Input id={"indirizzo1"} ariaLabel={"Via/Piazza residenza (obbligatorio)"} style={{width: isPageWide ? "60%" : "90%"}}
                                       value={state.indirizzi && state.indirizzi[0] && state.indirizzi[0].indirizzo ? state.indirizzi[0].indirizzo : ""}
                                       onChange={(event) => riceviValore(event.target.id, event.target.value, 0, "indirizzi")}
                                       placeholder={"Via"}/>
                            </div>
                            <div className={"col-2"}>
                                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>N.<span
                                    className={"obbligatorietaColor"}>*</span></span>
                                <br/>
                                <Input id={"numeroCivico1"} ariaLabel={"N. residenza (obbligatorio)"} style={{width: isPageWide ? "48%" : "85%"}}
                                       value={state.indirizzi && state.indirizzi[0] && state.indirizzi[0].numeroCivico ? state.indirizzi[0].numeroCivico : ""}
                                       onChange={(event) => riceviValore(event.target.id, event.target.value, 0, "indirizzi")}
                                       placeholder={"Numero"}/>
                            </div>
                        </div>
                        <div className={"row"} style={{marginTop: "10px"}}>
                            <div className={"col-4"}>
                                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Comune (o Stato Estero)<span
                                    className={"obbligatorietaColor"}>*</span></span>
                                <br/>
                                <Autocomplete id={"comune1"} ariaLabel={"Comune (o Stato Estero) residenza (obbligatorio)"} style={{width: isPageWide ? "60%" : "90%"}}
                                              value={state.indirizzi && state.indirizzi[0] && state.indirizzi[0].comune ? state.indirizzi[0].comune : ""}
                                              onChange={riceviValore}
                                              placeholder={"Comune"}
                                              suggestions={comuniAndNazioni}
                                              rerender={rerenderAutocomplete}
                                              index={0} nomeOggetto={"indirizzi"}
                                />
                            </div>
                            <div className={"col-2"}>
                                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Provincia
                                    {state.indirizzi && state.indirizzi[0] && state.indirizzi[0].comune && state.indirizzi[0].comune.codice && state.indirizzi[0].comune.codice.length <= 4 ? <></> :
                                        <span className={"obbligatorietaColor"}>*</span>}
                                </span>
                                <br/>
                                <Autocomplete id={"provincia1"} ariaLabel={"Provincia residenza (obbligatorio)"} style={{width: isPageWide ? "48%" : "85%"}}
                                              value={state.indirizzi && state.indirizzi[0] && state.indirizzi[0].provincia ? state.indirizzi[0].provincia : ""}
                                              onChange={riceviValore}
                                              rerender={rerenderAutocomplete}
                                              disabled={state.indirizzi && state.indirizzi[0] && state.indirizzi[0].comune && state.indirizzi[0].comune.codice && state.indirizzi[0].comune.codice.length <= 4}
                                              index={0} nomeOggetto={"indirizzi"}
                                              placeholder={"Provincia"} suggestions={province}/>
                            </div>
                            <div className={"col-2"}>
                                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>CAP
                                    {state.indirizzi && state.indirizzi[0] && state.indirizzi[0].comune && state.indirizzi[0].comune.codice && state.indirizzi[0].comune.codice.length <= 4 ? <></> :
                                        <span className={"obbligatorietaColor"}>*</span>}
                                </span>
                                <br/>
                                <Input id={"cap1"} ariaLabel={"CAP residenza (obbligatorio)"} style={{width: isPageWide ? "48%" : "85%"}}
                                       value={state.indirizzi && state.indirizzi[0] && state.indirizzi[0].cap ? state.indirizzi[0].cap : ""}
                                       onChange={(event) => riceviValore(event.target.id, event.target.value, 0, "indirizzi")}
                                       disabled={state.indirizzi && state.indirizzi[0] && state.indirizzi[0].comune && state.indirizzi[0].comune.codice && state.indirizzi[0].comune.codice.length <= 4}
                                       placeholder={"Cap"}/>
                            </div>
                        </div>
                        <div className={"row"} style={{marginTop: "10px", marginBottom: "2rem"}}>
                            <div className={"col-4"}>
                                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Presso</span>
                                <br/>
                                <Input id={"presso1"} ariaLabel={"Presso residenza"} style={{width: isPageWide ? "60%" : "90%"}}
                                       value={state.indirizzi && state.indirizzi[0] && state.indirizzi[0].presso ? state.indirizzi[0].presso : ""}
                                       onChange={(event) => riceviValore(event.target.id, event.target.value, 0, "indirizzi")}
                                       placeholder={"Presso"}/>
                            </div>
                        </div>
                    </div>
                }


                <div className={"col-12"} style={{marginTop: "10px"}}>
                    <div className={"row"}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050", marginTop: ".8rem"}}>Domicilio diverso da residenza?</span>
                        <RadioButton id={"residenzaDiversaDomicilioSi"}
                                     text={"Si"}
                                     onChange={(event) => ricevivaloreRadioButtonDomicilio(event.target.id, event.target.value)}
                                     value={"true"}
                                     checked={state && state.residenzaDiversaDomicilio && state.residenzaDiversaDomicilio === "true"}
                        >
                        </RadioButton>
                        <RadioButton id={"residenzaDiversaDomicilioNo"}
                                     text={"No"}
                                     value={"false"}
                                     onChange={(event) => ricevivaloreRadioButtonDomicilio(event.target.id, event.target.value)}
                                     checked={state && state.residenzaDiversaDomicilio && state.residenzaDiversaDomicilio === "false"}
                        />
                    </div>
                </div>
                <span style={{fontWeight: "bold"}}>Domicilio</span>
                <div>
                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={"col-4"}>
                                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>
                                    Via/Piazza
                                    {state && state.residenzaDiversaDomicilio === "true" ?
                                        <span className={"obbligatorietaColor"}>*</span> : <></>}
                                </span>
                            <br/>
                            <Input id={"indirizzo2"} ariaLabel={"Via/Piazza domicilio (obbligatorio)"} style={{width: isPageWide ? "60%" : "90%"}}
                                   value={state.indirizzi && state.indirizzi[1] && state.indirizzi[1].indirizzo ? state.indirizzi[1].indirizzo : ""}
                                   onChange={(event) => riceviValore(event.target.id, event.target.value, 1, "indirizzi")}
                                   disabled={state && state.residenzaDiversaDomicilio === "false"}
                                   placeholder={"Via"}/>
                        </div>
                        <div className={"col-2"}>
                            <span style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                color: "#505050"
                            }}>N.{state && state.residenzaDiversaDomicilio === "true" ?
                                <span className={"obbligatorietaColor"}>*</span> : <></>}</span>
                            <br/>
                            <Input id={"numeroCivico2"} ariaLabel={"N. domicilio (obbligatorio)"} style={{width: isPageWide ? "48%" : "85%"}}
                                   value={state.indirizzi && state.indirizzi[1] && state.indirizzi[1].numeroCivico ? state.indirizzi[1].numeroCivico : ""}
                                   onChange={(event) => riceviValore(event.target.id, event.target.value, 1, "indirizzi")}
                                   disabled={state && state.residenzaDiversaDomicilio === "false"}
                                   placeholder={"Numero"}/>
                        </div>
                    </div>
                    <div className={"row"} style={{marginTop: "10px"}}>
                        <div className={"col-4"}>
                            <span style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                color: "#505050"
                            }}>Comune (o Stato estero){state && state.residenzaDiversaDomicilio === "true" ?
                                <span className={"obbligatorietaColor"}>*</span> : <></>}</span>
                            <br/>
                            <Autocomplete id={"comune2"} ariaLabel={"Comune (o Stato estero) domicilio (obbligatorio)"} style={{width: isPageWide ? "60%" : "90%"}}
                                          value={state.indirizzi && state.indirizzi[1] && state.indirizzi[1].comune ? state.indirizzi[1].comune : ""}
                                          onChange={riceviValore}
                                          placeholder={"Comune"}
                                          suggestions={comuniAndNazioni}
                                          rerender={rerenderAutocomplete}
                                          disabled={state && state.residenzaDiversaDomicilio === "false"}
                                          index={1} nomeOggetto={"indirizzi"}
                            />
                        </div>
                        <div className={"col-2"}>
                            <span style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                color: "#505050"
                            }}>Provincia{(state && state.residenzaDiversaDomicilio === "true" )||(state.indirizzi && state.indirizzi[1] && state.indirizzi[1].comune && state.indirizzi[1].comune.codice && state.indirizzi[1].comune.codice.length <= 4) ? <></> :
                                <span className={"obbligatorietaColor"}>*</span>}
                            </span>
                            <br/>
                            <Autocomplete id={"provincia2"} ariaLabel={"Provincia domicilio (obbligatorio)"} style={{width: isPageWide ? "48%" : "85%"}}
                                          value={state.indirizzi && state.indirizzi[1] && state.indirizzi[1].provincia ? state.indirizzi[1].provincia : ""}
                                          onChange={riceviValore}
                                          rerender={rerenderAutocomplete}
                                          index={1} nomeOggetto={"indirizzi"}
                                          disabled={(state && state.residenzaDiversaDomicilio === "false")||(state.indirizzi && state.indirizzi[1] && state.indirizzi[1].comune && state.indirizzi[1].comune.codice && state.indirizzi[1].comune.codice.length <= 4)}
                                          placeholder={"Provincia"} suggestions={province}/>
                        </div>
                        <div className={"col-2"}>
                            <span style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                color: "#505050"
                            }}>CAP
                                {(state && state.residenzaDiversaDomicilio === "true")||(state.indirizzi && state.indirizzi[1] && state.indirizzi[1].comune && state.indirizzi[1].comune.codice && state.indirizzi[1].comune.codice.length <= 4) ? <></> :
                                    <span className={"obbligatorietaColor"}>*</span>}</span>
                            <br/>
                            <Input id={"cap2"} ariaLabel={"CAP domicilio (obbligatorio)"} style={{width: isPageWide ? "48%" : "85%"}}
                                   value={state.indirizzi && state.indirizzi[1] && state.indirizzi[1].cap ? state.indirizzi[1].cap : ""}
                                   onChange={(event) => riceviValore(event.target.id, event.target.value, 1, "indirizzi")}
                                   disabled={(state && state.residenzaDiversaDomicilio === "false")||(state.indirizzi && state.indirizzi[1] && state.indirizzi[1].comune && state.indirizzi[1].comune.codice && state.indirizzi[1].comune.codice.length <= 4)}
                                   placeholder={"Cap"}/>
                        </div>
                    </div>
                    <div className={"row"} style={{marginTop: "10px", marginBottom: "2rem"}}>
                        <div className={"col-4"}>
                            <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Presso</span>
                            <br/>
                            <Input id={"presso2"} ariaLabel={"Presso domicilio"} style={{width: isPageWide ? "60%" : "90%"}}
                                   value={state.indirizzi && state.indirizzi[1] && state.indirizzi[1].presso ? state.indirizzi[1].presso : ""}
                                   onChange={(event) => riceviValore(event.target.id, event.target.value, 1, "indirizzi")}
                                   disabled={state && state.residenzaDiversaDomicilio === "false"}
                                   placeholder={"Presso"}/>
                        </div>
                    </div>
                </div>


                <div className={"row"}
                     style={{borderBottom: "2px solid #d9dadb", paddingBottom: "1rem", paddingTop: "1rem"}}>
                    <div className={isPageWide ? "col-10" : "col-7"}>
                        <span style={{color: "#909090", fontWeight: "bold"}}>Contatti</span>
                    </div>
                    <div className={isPageWide ? "col-2" : "col-5"}>
                        <span style={{color: "red", fontWeight: "bold"}}>*Campo Obbligatorio</span>
                    </div>
                </div>

                <div className={"col-12"} style={{marginTop: "1rem"}}>
                    <div className={"row"}>
                        <div className={"col-3"}>
                            <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Telefono</span>
                            <br/>
                            <Input id={"telefono"} ariaLabel={"Telefono"} style={{width: isPageWide ? "80%" : "100%"}}
                                   value={state && state.contatti && state.contatti[0] && state.contatti[0].telefono ? state.contatti[0].telefono : ""}
                                   onChange={(event) => riceviValore(event.target.id, event.target.value, 0, "contatti")}
                                   placeholder={"Telefono"}/>
                        </div>
                        <div className={"col-3"}>
                            <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Cellulare<span
                                className={"obbligatorietaColor"}>*</span></span>
                            <br/>
                            <Input id={"cellulare"} ariaLabel={"Cellulare (obbligatorio)"} style={{width: isPageWide ? "80%" : "100%"}}
                                   value={state && state.contatti && state.contatti[0] && state.contatti[0].cellulare ? state.contatti[0].cellulare : ""}
                                   onChange={(event) => riceviValore(event.target.id, event.target.value, 0, "contatti")}
                                   placeholder={"Cellulare"}/>
                        </div>
                    </div>
                    <div className={"row"} style={{marginTop: "10px", marginBottom: "2rem"}}>
                        <div className={"col-3"}>
                            <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>E-mail</span>
                            <br/>
                            <Input id={"email"} ariaLabel={"E-mail"} style={{width: isPageWide ? "80%" : "100%"}}
                                   value={state && state.contatti && state.contatti[0] && state.contatti[0].email ? state.contatti[0].email : ""}
                                   onChange={(event) => riceviValore(event.target.id, event.target.value, 0, "contatti")}
                                   placeholder={"Email"}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>)


}

export default DatiAnagrafici
